import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: '此圖像缺少替代文字',
    noAnswers: '沒有答案選項，請按下一步繼續。',
    placeholder: '請註明...',
    pleaseSelect: '請選擇……',
    rotateLandscape: '請關閉手機上的方向鎖定並旋轉到橫向繼續。',
    rotatePortrait: '請將手機從橫向旋轉到直向繼續。',
    ir: {
      selectWebCam: '選擇網絡攝影機（如有），或按「瀏覽」從裝置上載',
      noWebCam: '沒有發現網絡攝影機',
      accessCamUpload: '存取攝影機／上載',
      browse: '瀏覽',
      uploadPhoto: '上載一張照片',
      camera: '網絡攝影機',
      instead: '或者',
      capture: '拍攝照片',
      somethingWrong: '抱歉，出現錯誤。請稍後再試',
      couldntRead: '抱歉，我們無法閱讀代碼！',
      couldntProcess: '抱歉，我們無法處理您的圖片！',
      inValidCode: '請提交有效的代碼',
      moveOn: '請重試或提交照片，然後繼續',
      tryAgain: '請重試',
      dataReceived: '已收到數據！',
      enterManually: '請重試或在下方手動輸入數據',
      positionQR: '請將二維碼放在相機前，置於紅框範圍內，或從電腦上載。',
      positionQRMobile: '請將二維碼放在相機前，置於紅框範圍內，或從電腦上載。',
      analyzing: '正在分析圖片，請稍候',
      submit: '提交',
      startOver: '重新開始',
      allDone: '全部完成！',
      cantAnalyze:
        '注意—我們無法採用此圖片。請嘗試重新提交，看看我們是否能接受，或選擇更通用的圖片格式（JPG、PNG、GIF、BMP）',
      wrongFormat: '很抱歉—我們不支援此檔案格式。請上載支援的圖片類型（JPG、PNG、GIF、BMP、TIF、PDF、SVG）'
    },
    vr: {
      selectWebCam: '選擇網絡攝影機（如有），或按「瀏覽」從裝置上載',
      noWebCam: '沒有發現網絡攝影機',
      uploadVideo: '上載影片',
      skip: '跳過？',
      accessCamUpload: '存取攝影機／上載',
      browse: '瀏覽',
      instead: '或者',
      or: '或者',
      stopRecording: '停止錄製',
      willBeStopped: '5 分鐘後會停止錄製',
      stopOnDone: '完成時請停止錄製！',
      record: '錄製',
      somethingWrong: '抱歉，出現錯誤。請稍後再試',
      dataReceived: '已收到數據！',
      microphone: '網絡攝影機',
      camera: 'Web Camera',
      selectMicrophone: '選擇您的麥克風',
      selectCam: '選擇您的網絡攝影機',
      submit: '提交',
      upload: '上載新回覆',
      playback: '回放',
      stopPlayback: '停止播放',
      startOver: '重新開始',
      allDone: '全部完成！',
      alternativeRecordSpan: '請從電腦設備上載影片，或者使用攝網絡影機錄製影片。',
      alrenativeRecordHref: '',
      cantAnalyze:
        '注意—我們無法採用此影片。請嘗試重新提交，看看我們是否能接受，或選擇更通用的影片格式（MP4、M4V、WEBPM）',
      wrongFormat: '很抱歉—我們不支援此檔案格式。請上載支援的影片類型（MP4、AVI、M4V、WEBPM、MOV、MKV、MPG、WMV）'
    },
    cjc: {
      choose: '選擇',
      pleaseChoose: '請選擇',
      this: '此',
      one: '一',
      myChoice: '我的選擇'
    },
    hm: {
      addComment: '請在下方新增評論',
      commentMandatoryPlaceHolder: '請新增強制性評論...',
      commentOptionalPlaceHolder: '請新增選填評論...',
      dragPin: '拉動以改變位置（長按／長觸以準確固定位置）。',
      removePin: '拉到圖片外刪除。',
      editComment: '按下／輕觸圖釘以編輯評論。',
      addPin: '請在下方面板拉動圖釘，然後置於您在圖片中選擇的位置。',
      addPins: '請在下方面板拉動圖釘，然後置於您在圖片中選擇的位置。',
      leavePins: (minPoints, maxPoints) => `每種圖釘請加入至少 ${minPoints} 個但不超過 ${maxPoints} 個。`,
      leavePinsAny: (minPoints, maxPoints) => `請加入至少 ${minPoints} 但不超過 ${maxPoints} 個任何類別的圖釘。`,
      leavePinsPerPage: (minPoints, maxPoints) => `請加入至少 ${minPoints} 個但不超過 ${maxPoints} 個圖釘。`,
      leavePinsWithOff: maxPoints => `每種圖釘請加入不多於 ${maxPoints} 個，或按下一步跳過。`,
      leavePinsWithOffAny: maxPoints => `請加入不超過 ${maxPoints} 個任意類別的圖釘，或按「下一步」跳過。`,
      leavePinsPerPageWithOff: maxPoints => `請加入不多於 ${maxPoints} 個圖釘，或按下一步跳過。`,
      leavePinWithOff: `每種圖釘請加入不多於 1 個，或按下一步跳過。`,
      leavePinWithOffAny: `請加入不超過 1 個任何類別的圖釘，或按「下一步」跳過。`,
      leavePinPerPageWithOff: '請加入不多於 {max} 個圖釘，或按下一步跳過。',
      leaveExactlyPin: `每種圖釘請加入 1 個。`,
      leaveExactlyPinAny: `請加入 1 個任何類別的圖釘。`,
      leaveExactlyPinPerPage: '請加入 1 個圖釘。',
      leaveExactlyPins: maxPoints => `每種圖釘請加入 ${maxPoints} 個。`,
      leaveExactlyPinsAny: maxPoints => `請加入 ${maxPoints} 個任何類別的圖釘。`,
      leaveExactlyPinsPerPage: maxPoints => `請加入 ${maxPoints} 個圖釘。`,
      leaveComment: '請在圖片下方輸入評論。',
      noAnswers: '沒有答案選項，請按下一步繼續。',
      outOfPins: '您的圖釘已用完',
      pinsBehavior: '當你在圖像上移動時，你會看到一些只需放下一口圖釘便可突出顯示的區域。',
      clusters: '你只能在這些突出顯示的區域中放置圖釘。',
      contentAware: '你可以在突出顯示區域的裡面或外面放下圖釘。'
    },
    mp: {
      expand_note: '請將滑鼠懸停在圖片上或點擊圖片以展開。',
      rb_note: _rows => '請為以下每項各選1個答案：',
      cb_note: (min, max, _rows) => {
        if (min === max) {
          return `請為下列每項${min !== 1 ? '選擇任意' : '僅選擇'} ${min}個回答：`
        } else if (min > 0 && max < 5000) {
          return `對於以下每項，請選擇至少${min}個答案 ，但不要超過${max}個：`
        } else if (5000 === max && min > 0) {
          return `對於以下每項，請選擇至少${min}個答案 ：`
        } else if (0 === min && max < 5000) {
          return `對於以下每項，請不要選擇超過${max}個答案：`
        } else {
          return '請勾選所有適用項目：'
        }
      }
    },
    sh: {
      note: '如果您想在商店中購買產品，請按產品放大，然後加入您的虛擬購物車中',
      amazonNote: '點按產品，將其放大，並添加到您的虛擬購物車中。',
      fullCart: '您的購物車已滿！',
      qty: '數量',
      addToCart: '加入購物車',
      deleteFromCart: '刪除',
      emptyCard: '您的購物車是空的',
      each: '每個',
      items: '項目',
      total: '購物車',
      clearCart: '清空購物車',
      backToStore: '返回商店',
      na: '以上皆非',
      next: '下一步',
      maxCartCountError: max => `请在您的购物车中添加不超过${max}种产品`,
      scrollError: `請完全向左右捲動以繼續此問卷調查。 `,
      maxSpentError: max => `请花费不超过${max}。 `,
      maxProductCountError: max => `在购物车中添加每种产品的数量请不要超过${max}。`
    },
    rb: {
      note: '請僅選擇 1 項：'
    },
    vo: {
      note: '請觀看影片到最後'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `請選擇${min !== 1 ? '任何' : '僅'} ${min}項：`
        } else if (min > 0 && max < 5000) {
          return `請選擇至少 ${min} 項，但每欄不得超過 ${max}: 項：`
        } else if (5000 === max && min > 0) {
          return `請選擇至少 ${min}項：`
        } else if (0 === min && max < 5000) {
          return `請選擇不超過 ${max}项：`
        } else {
          return '請勾選所有適用項目：'
        }
      }
    },

    oe: {
      na: '不适用',
      note: (min, max, optional) => {
        if (min === max) {
          return `請輸入${1 !== min ? '任何' : '剛好'} ${min} 個字符${optional ? '（選填）' : ''}：`
        } else if (min > 0 && max < 5000) {
          return `請輸入至少 ${min} 個字符 但不超過${max}${optional ? '（選填）' : ''}：`
        } else if (5000 === max && min > 0) {
          return `請輸入至少 ${min} 個字符${optional ? '（選填）' : ''}：`
        } else if (0 === min && max < 5000) {
          return `請輸入不超過 ${max} 個字符${optional ? '（選填）' : ''}：`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: '請填寫以下各欄：'
    },
    mx: {
      note: '請移動突出顯示的滑塊繼續',
      dragSlider: '向左或向右拉動回答'
    },
    psc: {
      dragLeftRight: '向左或向右拉動回答'
    },
    ps: {
      note: value => `請在以下項目之間分配 ${value}`,
      allDone: `全部完成`,
      total: `全部的：`,
      dragSlider: '向左或向右拉動回答'
    },
    cx: {
      note: '打開共用資料夾，開始輸入答案以滾動或手動選擇'
    },
    ro: {
      note: '向上或向下拉動以重新排序：'
    },
    md: {
      note1: '請按下／輕觸您的第一選擇<br/>再次按下／輕觸以清除選擇。',
      note2: '現在，請按下／輕觸您的最後選擇.<br/>再次按下／輕觸以清除選擇。',
      note3: '謝謝！繼續前往下一個問題或按下／輕觸任何未選擇的項目，以重新開始。'
    },
    aro: {
      note: '請在以下每組中選擇一項。'
    },
    wd: {
      note: '請確認每項之後的值高於上一個值。'
    },
    emd: {
      note: '請觀看影片到最後',
      noAnswers: '沒有答案選項，請按下一步繼續。',
      start: '點擊並按住以開始',
      resume: '點擊並按住以繼續',
      continue: '您準備好了！<br /> 按下一步繼續',
      continueMobile: '您準備好了！<br /> 點擊此處繼續',
      training: {
        session: '培訓課程',
        note: '請完成培訓',
        moveLeft: '請將調節器拉到最左邊',
        moveBottom: '請將調節器拉到底部',
        moveRight: '現在，請將調節器拉到最右邊',
        moveTop: '現在，請將調節器拉到頂部',
        success: '做得好'
      }
    },
    sft: {
      noAnswers: '沒有答案選項，請按下一步繼續。',
      note: '請用最快的速度以直覺回答',
      finish: '大功告成！請按下一步繼續',
      training: {
        start:
          '<p>此問題會向您快速顯示不同單詞，並且需要您集中注意力。' +
          '您需要反應快速地回答</p> <p>準備好練習了嗎？</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `按 "{buttonLeft}"`
            : (mouse ? `按 "{buttonLeft}"` : '') + (key && mouse ? ' / ' : '') + (key ? `按 "{keyBtnLeft}" 按` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `按 "{buttonRight}"`
            : (mouse ? `按 "{buttonRight}"` : '') + (key && mouse ? ' / ' : '') + (key ? `按 "{keyBtnRight}" 按` : ''),
        fail: () => '太慢了',
        success: () => '太棒了！',
        finish: () =>
          '<p><strong> 優秀！</strong></p><p>請確保您在接下來的 2-3 分鐘不會分心</p><p>準備好就可以按「下一步」開始</p>'
      },
      buttons: {
        start: '開始',
        yesno: {
          left: '是',
          right: '否'
        },
        matches: {
          left: '匹配',
          right: '不匹配'
        },
        fits: {
          left: '合適',
          right: '不合適'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: '是',
          right: '否'
        },
        matchesRev: {
          left: '匹配',
          right: '不匹配'
        },
        fitsRev: {
          left: '合適',
          right: '不合適'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
